import React from 'react';
import { motion } from 'framer-motion';
import { ChartAreaInteractive } from '@/components/ChartAreaInteractive';
import { ChartBarMultiple } from '@/components/charts/ChartBarMultiple';
import { ChartPieDonut } from '@/components/charts/ChartPieDonut';
import { ChartRadarMultiple } from '@/components/charts/ChartRadarMultiple';
import { ChartRadialStacked } from '@/components/charts/ChartRadialStacked';
import { ChartAreaGradient } from '@/components/charts/ChartAreaGradient';

export default function Analytics() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
      className="w-full"
    >
      {/* Page Header */}
      <div className="mb-8">
        <h1 className="text-4xl sm:text-5xl font-heading font-semibold text-zinc-100 mb-2">
          Analytics
        </h1>
        <p className="text-zinc-500 text-base">
          Monitor your financial metrics and trends
        </p>
      </div>

      {/* Charts Grid */}
      <div className="space-y-6">
        {/* Interactive Area Chart - Full Width */}
        <ChartAreaInteractive />

        {/* Two Column Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <ChartBarMultiple />
          <ChartAreaGradient />
        </div>

        {/* Three Column Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <ChartPieDonut />
          <ChartRadarMultiple />
          <ChartRadialStacked />
        </div>
      </div>
    </motion.div>
  );
}
